import React, { useEffect, useState } from 'react';
import { Button, DefaultInput, DefaultSelect } from 'ui-kit-takeat';
import { DiscountInfoTable, StyledModal } from './styles';
import { CurrencyInput } from '~/components/CurrencyInput';
import formatValue from '~/utils/formatValue';
import { useAuth } from '~/context/AuthContext';
import toast from 'react-hot-toast';
import api2 from 'services/api2';

export const ModalDiscount = ({
  isOpen,
  setIsOpen,
  //total,
  session,
  completeSession,
  diferenca,
  discountApplied
}) => {
  const { user, restaurantDiscountObs } = useAuth();
  const [discount, setDiscount] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [discountObs, setDiscountObs] = useState(null);
  const [discountMotive, setDiscountMotive] = useState('');
  const [discountObservation, setDiscountObservation] = useState(null);
  const [adminPassword, setAdminPassword] = useState('');
  const [isApplyingDiscount, setIsApplyingDiscount] = useState(false);
  const [discountObsOptions, setDiscountObsOptions] = useState([]);


const isDelivery = session?.table.table_type === 'delivery' 

const [typingAbsolute, setTypingAbsolute] = useState(false);
const [typingPercent, setTypingPercent] = useState(false);

function resetDiscount(){
  setDiscount(0);
  setDiscountPercent(0);
  setDiscountObs(null);
  setDiscountMotive('');
  setDiscountObservation(null);
  setAdminPassword('');
  setIsApplyingDiscount(false);
  setTypingAbsolute(false);
  setTypingPercent(false);
}

 useEffect(() => {
    const obs_options = restaurantDiscountObs?.map((disc) => ({
      value: disc.id,
      label: disc.obs,
    }));
    setDiscountObsOptions([...obs_options, { value: 'other', label: 'Outro' }]);
  }, [restaurantDiscountObs]);

    // const handleDiscountUpdate = async () => {
    //   if (discount > 0) {
    //     try {
    //       const response = await api2.put(
    //         `/restaurants/delivery/orders/update/${session?.session_id}`,
    //         {
    //           discount: session?.discount_total ? parseFloat(discount) + parseFloat(session?.discount_total) : discountApplied > 0 ? parseFloat(discount) + parseFloat(discountApplied) : parseFloat(discount),
    //           discount_obs: discountObservation
    //           ? `${discountObs} - ${discountObservation}`
    //           : discountObs,
    //           user_id: user.user_id,
    //         }
    //       );
  
    //       console.log('res > ', response.data);
    //     } catch (err) {
    //       console.log('Error handleDiscountUpdate: ', err);
    //     }
    //   }
    // };

    const handleDiscountUpdate = async () => {
      if (discount > 0) {
        const session_id = isDelivery ? session?.session_id : session?.id;
        try {
          const currentDiscount = parseFloat(session?.discount_total || discountApplied || 0);
          const newDiscount = parseFloat(discount) + currentDiscount;
          
          const response = await api2.put(
            `/restaurants/delivery/orders/update/${session_id}`,
            {
              discount: newDiscount,
              discount_obs: discountObservation
                ? `${discountObs} - ${discountObservation}`
                : discountObs,
              user_id: user.user_id,
            }
          );
        } catch (err) {
          console.log('Error handleDiscountUpdate: ', err);
        }
      }
    };



  async function handleDiscount() {
    try {
      setIsApplyingDiscount(true);
      if (
        user.order_cancel_password !== '' &&
        (adminPassword === '' || !adminPassword)
      ) {
        toast.error('Insira a senha administrativa!');
        setIsApplyingDiscount(false);
        return false;
      }

      // Aplica o desconto primeiro
      await handleDiscountUpdate();

      // Depois finaliza a sessão (sem aplicar desconto de novo)
      completeSession();
      toast.success('Desconto aplicado e comanda finalizada!');
      resetDiscount();
      setIsApplyingDiscount(false);
    } catch (error) {
      setIsApplyingDiscount(false);
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error('Erro ao aplicar desconto');
      }
    }
  }

  return (
    <StyledModal isOpen={isOpen} toggle={() => setIsOpen((state) => !state)}>
      <h3>Aplicar desconto</h3>
      <p>Para finalizar a comanda, o desconto deverá ser de {formatValue(diferenca)}</p>

      <div style={{ display: 'flex', justifyContent: 'space-evenly', gap: '10px' }}>
        <CurrencyInput
          placeholder="R$"
          onChange={(e) => {
            const value = e.floatValue || 0;
            setDiscount((value / 100).toFixed(2));
            setDiscountPercent(
              diferenca === 0 ? 0 : ((value / 100 / diferenca) * 100).toFixed(2)
            );
            
            if (value > 0) {
              setTypingAbsolute(true);
              setTypingPercent(false);
            } else {
              setTypingAbsolute(false);
            }
          }}
          disabled={typingPercent}
        />
        <DefaultInput
          type='number'
          placeholder="%"
          style={{ height: '40px' }}
          onChange={(e) => {
            const value = e.target.value;
            setDiscountPercent(value);
            setDiscount((diferenca * (value / 100)).toFixed(2));
          
            if (value && Number(value) > 0) {
              setTypingPercent(true);
              setTypingAbsolute(false);
            } else {
              setTypingPercent(false);
            }
          }}
           disabled={typingAbsolute}
        />
      </div>

      <DiscountInfoTable>
        <div>
          <span>Desconto atual</span>
        </div>
        <div>
          <span>
            {formatValue(discount)} |{' '}
            {parseFloat(discountPercent || 0).toLocaleString('pt-br', {
              maximumFractionDigits: 2,
            })}
            %
          </span>
        </div>
      </DiscountInfoTable>

      <DefaultSelect
        label="Motivo"
        options={discountObsOptions}
        value={discountObsOptions.find((item) => item.value === discountObs)}
        onChange={(e) => {
          setDiscountObs(e.value);
          setDiscountMotive(e.label === 'Outro' ? '' : e.label);
        }}
      />
      {discountObs === 'other' && (
        <DefaultInput
          placeholder="Escreva o motivo"
          name="motive"
          value={discountMotive}
          onChange={(e) => setDiscountMotive(e.target.value)}
        />
      )}

      <DefaultInput
        type="text"
        placeholder="Observação"
        id="observation"
        name="observation"
        style={{ height: 40, padding: '7px 14px' }}
        value={discountObservation}
        onChange={(e) => setDiscountObservation(e.target.value)}
      />

      {user.order_cancel_password !== '' && (
        <DefaultInput
          title="Senha administrativa:"
          id="cancel_password"
          name="testing"
          type="password"
          autocomplete="new-password"
          value={adminPassword}
          onChange={(e) => setAdminPassword(e.target.value)}
        />
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button title="Cancelar" onClick={() => setIsOpen(false)} />
        <Button
          title="Aplicar desconto e finalizar"
          buttonColor="#2ec9b7"
          onClick={() => {
            if (adminPassword !== user.order_cancel_password) {
              toast.error('Senha administrativa incorreta');
            } else {
             handleDiscount()
            }
          }}
          disabled={
            discountPercent > 100 ||
            discountPercent === 0 ||
            discountPercent < 100 ||
            discountObs === '' ||
            !discountObs ||
            isApplyingDiscount
          }
        />
      </div>
    </StyledModal>
  );
};
